/// <reference path="../services/datacontext.js" />
// app/tirocinante/aziende.js

(function () {
	'use strict';
    var controllerId = 'cndDomandaAdesione';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', cndDomandaAdesione]);

    function cndDomandaAdesione($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter) {
		var getLogFn = common.logger.getLogFn;
		var log = getLogFn(controllerId);
		var logError = getLogFn(controllerId, 'logError');
		var logSuccess = getLogFn(controllerId, 'logSuccess');


		var vm = this;
		vm.title = 'domandaAdesione';
        vm.view = 'adesioneForm';       //Opzione list or detail
		vm.setView = setView;
		vm.sectionMenu = sectionMenu.setSection(vm.title);

		vm.objName = "domandaAdesione"; //Utilizzato per pannello authorization		
		vm.authorization = {};
		vm.showObjPanel = false;
		vm.record = {};
		vm.records = [];
		vm.countRecords = 0;
		vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        //Pannelli dei dati domanda di adesione
        vm.showPanel2 = true;
        vm.setShowPanel2 = setShowPanel2;
        vm.showPanel3 = true;
        vm.setShowPanel3 = setShowPanel3;
        vm.showPanel4 = true;
        vm.setShowPanel4 = setShowPanel4;
        //Pannelli dei dati CV
        vm.showPanel_cv2 = true;
        vm.setShowPanel_cv2 = setShowPanel_cv2;
        vm.showPanel_cv3 = true;
        vm.setShowPanel_cv3 = setShowPanel_cv3;
        vm.showPanel_cv4 = true;
        vm.setShowPanel_cv4 = setShowPanel_cv4;
        vm.showPanel_cv5 = true;
        vm.setShowPanel_cv5 = setShowPanel_cv5;
        vm.ableMenu = true;
        vm.showToggle = true;


        vm.getConfirmEmail = getConfirmEmail;
        vm.getConfirmPEC = getConfirmPEC;
        vm.validEmail = true;
        vm.validPEC = true;
        

        vm.addDisabled = false;
		vm.exportDisabled = false;
		vm.pageSize = 30;
		vm.page = 1;
        vm.loading = false;
        vm.saving = false;
        vm.PdfReady = true;

        vm.cndProgetto = {};
        vm.showDivs = {};
        vm.showDivs.ableToAccess = false;
        vm.showDivs.callExpired = false;
        vm.showDivs.enableBeforeStart = false;
        vm.showDivs.linkError = false;

		//Elenco per Ordinamento
		vm.list = {};
		vm.list.ordine = ['Nominativo', 'Codice Fiscale'];
		vm.ordine = vm.list.ordine[0];
		vm.selectOrdine = function (item) {
			vm.ordine = item;
		};

		//Elenchi dettaglio
		vm.list.attach = [];
		
		vm.list.b_attach = false;
		

		//vm.getRecord = getRecord;
		vm.getListAttach = getListAttach;

		//Conteggio Elenchi
		vm.countAttachProfilo = function () {
			var filter = {};
			return filterFilter(vm.list.attach, filter).length;
		}

        vm.saveAll = saveAll;

        

        //CND CV
        vm.currVitae = {};
        vm.resetTitoloFields = resetTitoloFields;

        //CNDCV_Spec
        vm.cv_spec = {};
        vm.list.cv_specs = [];
        vm.addSpec = addSpec;
        vm.deleteSpec = deleteSpec;


        //CNDCV_Servizio
        vm.cv_servizio = {};
        vm.list.cv_servizi = [];
        vm.addServizio = addServizio;
        vm.deleteServizio = deleteServizio;


		//Filtro
		vm.fNominativo = '';
		vm.fNascComuneId = -1;

		vm.fAttach = {};
		vm.setfAttach = setfAttach;

		//Elenchi per filtri e finestra modale di Create
        vm.cmblist = {};
        vm.cmblist.nasc_paesi = [];
        vm.cmblist.nasc_province = [];
        vm.cmblist.nasc_comuni = [];
        
        vm.cmblist.res_paesi = [];
        vm.cmblist.res_province = [];
        vm.cmblist.res_comuni = [];
        
        vm.cmblist.dom_paesi = [];
        vm.cmblist.dom_province = [];
        vm.cmblist.dom_comuni = [];

        vm.cmblist.staticivili = [];
        vm.cmblist.profili = [];
        vm.cmblist.titoliStudio = [];
        vm.cmblist.mesi = [
            { Id: 1, Name: 'Gennaio' },
            { Id: 2, Name: 'Febbraio' },
            { Id: 3, Name: 'Marzo' },
            { Id: 4, Name: 'Aprile' },
            { Id: 5, Name: 'Maggio' },
            { Id: 6, Name: 'Giugno' },
            { Id: 7, Name: 'Luglio' },
            { Id: 8, Name: 'Agosto' },
            { Id: 9, Name: 'Settembre' },
            { Id: 10, Name: 'Ottobre' },
            { Id: 11, Name: 'Novembre' },
            { Id: 12, Name: 'Dicembre' }
        ];

        vm.cmblist.dich1_02_cittadinanze = [];
        vm.cmblist.dich1_03_province = [];
        vm.cmblist.dich1_03_comuni = [];
        vm.cmblist.statiOccup = [];

        vm.tSource = {};
        vm.tAttach = [];
        vm.tAttach_Needed = [];


		//Metodi su interfaccia
		vm.activated = false;
		vm.addAttach = addAttach;
        vm.deleteAttach = deleteAttach;

        //DA
        vm.setCompleted = setCompleted;
        vm.setSent = setSent;
        vm.unlock = unlockItem;
        //CV
        vm.setCompleted_CV = setCompleted_CV;
        vm.setSent_CV = setSent_CV;
        vm.unlock_CV = unlockCVItem;

        vm.containsGrado = containsGrado;
        vm.changedProfilo = false;
        vm.setChanged = setChanged;

		//vm.get = getRecord;
        vm.add = addModal;
        vm.update = saveOrUpdateItem;
		vm.delete = deleteItem;

        vm.resetComuni_Nasc = resetComuni_Nasc;
        vm.resetComuni_Res = resetComuni_Res;
        vm.resetComuni_Dom = resetComuni_Dom;
        vm.resetComuni_Dich1_03 = resetComuni_Dich1_03;

        vm.reset_PaeseNasc = reset_PaeseNasc;
        vm.reset_PaeseRes = reset_PaeseRes;
        vm.reset_PaeseDom = reset_PaeseDom;
        vm.reset_DomUgualeRes = reset_DomUgualeRes;
        vm.reset_Dich1_02 = reset_Dich1_02;
        vm.reset_Dich1_05_condanne = reset_Dich1_05_condanne;
        vm.reset_Dich1_08 = reset_Dich1_08;
        vm.reset_Dich2_09 = reset_Dich2_09;
        
        
	    
		//datapicker
		vm.open = function ($event, iOpened) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened1 = false;
			if (iOpened == 1)
				vm.opened1 = true;
		};

		vm.clear = function ($event, iOpened) {
			if (iOpened == 1) {
				vm.record.NascData = '';
				vm.changed = true;
			}
		};

		vm.dateOptions = {
			formatYear: 'yy',
			startingDay: 1
		};

		vm.format = 'dd/MM/yyyy';

		// ---- ACTIVATE -------
		activate();

		function activate() {
            var promises = [getTSource('ADES'), getTAttach('ADES'), getTAttachNeeded('ADES'), getTitoliStudio(), getStatiCivili(), getStatoOccup(), getPaesi_Nasc(), getProvincie_Nasc(), getPaesi_Res(), getProvincie_Res(), getPaesi_Dom(), getProvincie_Dom(), getCittadinanze_Dich1_02(), getProvincie_Dich1_03()];
			common.activateController(promises, controllerId)
							.then(function () {
                                vm.disableTornaIndietro = false;
                                setView('adesioneForm');
                                if ($routeParams.projectUID != null) {
                                    getCNDProgetto($routeParams.projectUID);
                                    sectionMenu.setProjectUId($routeParams.projectUID);
                                }

                                if ($routeParams.domandaAdesioneUID != null) {
                                    vm.Uid = $routeParams.domandaAdesioneUID;
                                    getRecordByUID(vm.Uid);
                                    getCV(vm.Uid);
                                    getPDFAdesione();
                                    getPDFCV();
                                }
                                else {
                                    vm.record.Id = 0;
                                    vm.record.NascPaeseId = 0;
                                    vm.record.ResPaeseId = 0;
                                    vm.record.DomPaeseId = 0;
                                    vm.record.Dich1_02_CittadinanzaId = 0;
                                }

								vm.sectionMenu = sectionMenu.setSection(vm.title);
								vm.activated = true;
							});
		}


		//****************************************************
		// METODI 
		//****************************************************
        function setView(view) {
			return vm.view = view;
		}

		

        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) { //Codice Progetto errato
                        vm.cndProgetto = {};
                        vm.showDivs.linkError = true;
                        vm.showDivs.callExpired = false;
                        vm.showDivs.enableBeforeStart = false;
                        vm.showDivs.ableToAccess = false;
                        vm.showDivs.ableToCV = false;
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        var dt = new Date();
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");

                        vm.showDivs.linkError = false;
                        vm.showDivs.enableBeforeStart = dt < dtStart;
                        vm.showDivs.callExpired = dt > dtEnd;
                        vm.showDivs.ableToAccess = !vm.showDivs.callExpired && !vm.showDivs.enableBeforeStart;
                        vm.showDivs.ableToCV = vm.cndProgetto.bCV;
                        vm.showDivs.ableToPDF1 = vm.cndProgetto.bPDF1;
                        vm.showDivs.ableToPDF2 = vm.cndProgetto.bPDF2;
                        
                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');

                        getProfili(vm.cndProgetto.Id);
                    }

                },
                //else
                function (data) {
                    vm.cndProgetto = {};
                    vm.showDivs.linkError = true;
                    vm.showDivs.enableBeforeStart = false;
                    vm.showDivs.callExpired = false;
                    vm.showDivs.ableToAccess = false;
                }
                );
        }

        //*************************************
        // Domanda di Adesione

        function setCompleted() {
            if (!vm.record.Sent && !vm.record.Completed)
                bDialog.confirmationDialog('Attenzione', 'Completando non sar\xE0 possibile apportare modifiche ai dati inseriti.', 'OK').then(
                    function () { //YES
                        vm.record.Completed = true;
                        vm.PdfReady = false;
                        return saveOrUpdateItem().then(function (data) {
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            return printPDF_DA().then(function (data1) {
                                vm.PdfReady = true;
                            });
                        });
                    },
                    function () { //NO
                        //vm.record.Completed = false;
                    }
                );
        }

        function unlockItem() {
            if (vm.record.Completed) {
                var item = vm.record;
                var msg = item.UId;
                bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare l\'adesione (' + msg + ')', 'OK').then(
                    function () { //YES
                        return datacontext.cndDomandaAdesione_unlock(item).then(function (data) {
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.record.Completed = false;
                            vm.records[vm.index] = vm.record;
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        function setSent() {
            if (!vm.record.Sent && vm.record.Completed)
                bDialog.confirmationDialog('Attenzione', 'Effettuando la trasmissione non sar\xE0 possibile caricare altri documenti.', 'OK').then(
                    function () { //YES
                        vm.record.Sent = true;
                        return saveOrUpdateItem().then(function (data) {
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                            }
                            return true;
                        });
                    },
                    function () { //NO
                        //vm.record.Completed = false;
                    }
                );
        }


        function setRecord(data) {
            vm.record = data;

            if (vm.record.NascData != null) vm.record.NascData = new Date(vm.record.NascData);
            if (vm.record.Email != null) vm.Confirm_Email = vm.record.Email;
            if (vm.record.PEC != null) vm.Confirm_PEC = vm.record.PEC;

            //Azzera liste
            vm.list.attach = [];
            vm.list.b_attach = false;
            vm.existsCF = false;

            //Aggiorno campi
            getComuni_Nasc(vm.record.NascProvinciaId);
            getComuni_Res(vm.record.ResProvinciaId);
            getComuni_Dom(vm.record.DomProvinciaId);

            getComuni_Dich1_03(vm.record.Dich1_03_ProvinciaId);
        }

        function getRecordByUID(uid) {
            if (vm.cmblist.nasc_province.length == 0) getProvincie_Nasc();
            if (vm.cmblist.res_province.length == 0) getProvincie_Res();
            if (vm.cmblist.dom_province.length == 0) getProvincie_Dom();

            return datacontext.cndDomandaAdesione_getByUID(uid, $routeParams.projectUID).then(function (data) {
                if (data == null) {
                    vm.showDivs.linkError = true;
                    vm.showDivs.callExpired = false;
                    vm.showDivs.ableToAccess = false;
                    return logError('Attenzione! Il link utilizzato e\' errato. ');
                }

                setRecord(data); //vm.record = data;                

                if (vm.record.Id > 0) {
                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                    vm.showInfoMsg = false;

                    //Riduco i pannelli dei dati dopo averli convalidati
                    vm.showPanel2 = false;
                    vm.showPanel3 = false;
                    vm.showPanel4 = false;
                }
                
                //Parametro di appoggio per send_Email
                vm.record.ProgettoUId = $routeParams.projectUID;

                setView('adesioneForm');
            });
        }

        $(document).on("contextmenu", "#confirm1", function (e) {
            logError('Attenzione: la funzionalit\xE0 \xE8 disabilitata. ');
            return false;
        });

        $(document).on("contextmenu", "#confirm2", function (e) {
            logError('Attenzione: la funzionalit\xE0 \xE8 disabilitata. ');
            return false;
        });

        function getConfirmEmail() {
            if (vm.Confirm_Email == '' || vm.Confirm_Email == null) return;

            if (vm.record.Email.toLowerCase() != vm.Confirm_Email.toLowerCase())
                vm.validEmail = false;
            else
                vm.validEmail = true;

            return vm.validEmail;
        }

        function getConfirmPEC() {
            if (vm.Confirm_PEC == '' || vm.Confirm_PEC == null) return;

            if (vm.record.PEC.toLowerCase() != vm.Confirm_PEC.toLowerCase())
                vm.validPEC = false;
            else
                vm.validPEC = true;

            return vm.validPEC;
        }

		function addRecord(id) {
			return datacontext.cndDomandaAdesione_get(id).then(function (data) {
				vm.records.push(data);
				vm.countRecords++;
			});
        }

        function containsGrado(index, profiloId) {
            index = parseInt(Math.pow(2, index));
            if ((index & profiloId) == index)
                return true;
            return false;
        }

        function setChanged() {
            if(!vm.changedProfilo)
                vm.changedProfilo = true;
            
            return vm.changedProfilo;
        }

        function setProfiloId() {
            if (vm.cndProgetto.iTProfilo == 2) {
                var sum = 0;
                $("input:checkbox[name=listId]:checked").each(function () {
                    var id = $(this).val();
                    var exp = id;
                    sum += parseInt(Math.pow(2, exp));
                });
                return vm.record.ProfiloId = sum;
            }
        }

        function saveOrUpdateItem() {
            unResetItem(vm.record);
            setProfiloId();
            vm.changedProfilo = false;
            vm.saving = true;

            if (vm.record == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Dopo il primo salvataggio non sar\xE0 pi\xF9 possibile modificare il campo "CODICE FISCALE". Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = $routeParams.projectUID;
                        return datacontext.cndDomandaAdesione_add(vm.record).then(function (data) {
                            if (data == "409") {
                                vm.saving = false;
                                logError('Errore: codice fiscale esistente. ');
                                return data;
                            }
                            if (data == "304") {
                                vm.saving = false;
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "417") {
                                vm.saving = false;
                                logError('Errore: importo ISEE oltre il valore consentito ');
                                return data;
                            }
                            if (data == "501") {
                                vm.saving = false;
                                logError('Errore: codice fiscale non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if ($.isNumeric(data)) {
                                vm.saving = false;
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;
                                $routeParams.domandaAdesioneUID = vm.record.UID;
                                getListAttach(vm.record.Id);
                                vm.saving = false;


                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;

                                    //Riduco i pannelli dei dati dopo averli convalidati
                                    vm.showPanel2 = false;
                                    vm.showPanel3 = false;
                                    vm.showPanel4 = false;
                                }

                                if (vm.showDivs.ableToPDF1) {
                                    logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con i dati inseriti. ');
                                    return true;
                                    /*
                                    return printPDF_DA().then(function (data) {
                                        logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con i dati inseriti. ');
                                        return data;
                                    });*/
                                }
                            }
                            vm.saving = false;
                        });
                    },
                    function () { //NO
                        vm.saving = false;
                    }
                );
            }
            else {
                return datacontext.cndDomandaAdesione_update(vm.record).then(function (data) {
                    console.info('save()', data);
                    if (data == "409") {
                        vm.saving = false;
                        logError("Attenzione dati mancanti. ");
                        return data;
                    }
                    if (data == "304") {
                        vm.saving = false;
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.record.Sent = false;
                        vm.saving = false;
                        logError("Attenzione mancano alcuni allegati, inserirli prima di effettuare la trasmissione. ");
                        return data;
                    }
                    if (data == "417") {
                        vm.saving = false;
                        logError('Errore: importo ISEE oltre il valore consentito ');
                        return data;
                    }
                    if ($.isNumeric(data)) {
                        vm.saving = false;
                        logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        $routeParams.domandaAdesioneUID = vm.record.UID;
                        getListAttach(vm.record.Id);

                        vm.saving = false;
                        if (vm.showDivs.ableToPDF1)
                        {
                            logSuccess('Dati salvati');
                            return true;
                            /*
                            return printPDF_DA().then(function (data) {

                                logSuccess('Dati salvati');
                                return data;
                            });*/
                        }
                    }
                    vm.saving = false;
                });
            }
        }

        //Sistemo i campi che ho resettato prima di mandarli al controller
        function unResetItem(item) {
            if (item.DomUgualeRes == 0) {
                item.DomPaeseId = 0;
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
                item.DomIndirizzo = '';
                item.DomCap = '';
            }

            if (item.NascPaeseId > 0) {
                item.NascProvinciaId = 0;
                item.NascComuneId = 0;
            }

            if (item.ResPaeseId > 0) {
                item.ResProvinciaId = 0;
                item.ResComuneId = 0;
            }

            if (item.DomPaeseId > 0) {
                item.DomProvinciaId = 0;
                item.DomComuneId = 0;
            }

            if (!item.Dich1_02) {
                item.Dich1_02_CittadinanzaId = 0;
            }
        }

		function deleteItem(item) {
			var msg = ' la domanda di adesione di : ' + item.CodiceFiscale;
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.cndDomandaAdesione_delete(item.Id).then(function (data) {
					if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

					var index = vm.records.indexOf(item)
					vm.records.splice(index, 1);
					vm.countRecords--;
				});
			});
        }

        //***************************
        // Get URL Allegato A

        function getPDFAdesione() {
            return datacontext.cndDomandaAdesione_getAllegatoA($routeParams.domandaAdesioneUID, $routeParams.projectUID)
                .then(function (data) {
                    
                    if (data && data.url) {
                        return vm.linkPDFAdesione = data.url;
                    }
                });
        }


        //*******************************
        // Print PDF DOMANDA DI ADESIONE

        function printPDF_DA() {
            if ($routeParams.domandaAdesioneUID == null)
                $routeParams.domandaAdesioneUID = vm.record.UID;

            return datacontext.cndDomandaAdesione_printPDF($routeParams.projectUID, $routeParams.domandaAdesioneUID)
                .then(function (data) {
                    
                    if (data && data.url) {
                        return vm.linkPDFAdesione = data.url;
                    }
                    else
                        return true;
                });
        }

		//List Methods
        function getListAttach(id) {
            if (!id) return;

            return datacontext.attach_getAllCND(0, 0, $routeParams.projectUID, $routeParams.domandaAdesioneUID, 'ADES', 0, id, vm.fAttach.TAttachId, '').then(function (data) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data)) vm.list.attach = data;
               
                return datacontext.tAttach_getAll(0, 0, 'ADES', 0, '', 0, '').then(function (data) {

                    vm.tAttach_Needed = data;

                    vm.tAttach_Needed.forEach(function (item_TA) {

                        var myrec = _.find(vm.list.attach, { 'TAttachId': item_TA.Id });

                        if (typeof (myrec) == 'undefined') {
                            if (typeof (vm.list.attach) == 'undefined') vm.list.attach = [];
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;
                            vm.list.attach.push(att);
                        }

                    });

                    return vm.list.attach;
                });
			});
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {
                return vm.tAttach_Needed = data;
            });
        }

        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        function setShowPanel2() {
            return vm.showPanel2 = !vm.showPanel2;
        }
        function setShowPanel3() {
            return vm.showPanel3 = !vm.showPanel3;
        }
        function setShowPanel4() {
            return vm.showPanel4 = !vm.showPanel4;
        }


        function setShowPanel_cv2() {
            return vm.showPanel_cv2 = !vm.showPanel_cv2;
        }
        function setShowPanel_cv3() {
            return vm.showPanel_cv3 = !vm.showPanel_cv3;
        }
        function setShowPanel_cv4() {
            return vm.showPanel_cv4 = !vm.showPanel_cv4;
        }
        function setShowPanel_cv5() {
            return vm.showPanel_cv5 = !vm.showPanel_cv5;
        }

        //*************************************
        // Curriculum Vitae

        function resetTitoloFields(index) {
            switch (index) {
                case 1:
                    if (!vm.currVitae.bTitolo01) {
                        vm.currVitae.Titolo01_Id = 0;
                        vm.currVitae.Titolo01_Desc = '';
                        vm.currVitae.Titolo01_Ist = '';
                        vm.currVitae.Titolo01_Mese = 0;
                        vm.currVitae.Titolo01_Anno = 0;
                        vm.currVitae.Titolo01_Voto = 0;
                        vm.currVitae.Titolo01_Max = 0;
                    }
                    break;
                case 2:
                    if (!vm.currVitae.bTitolo02) {
                        vm.currVitae.Titolo02_Id = 0;
                        vm.currVitae.Titolo02_Desc = '';
                        vm.currVitae.Titolo02_Ist = '';
                        vm.currVitae.Titolo02_Mese = 0;
                        vm.currVitae.Titolo02_Anno = 0;
                        vm.currVitae.Titolo02_Voto = 0;
                        vm.currVitae.Titolo02_Max = 0;
                    }
                    break;
                case 3:
                    if (!vm.currVitae.bTitolo03) {
                        vm.currVitae.Titolo03_Id = 0;
                        vm.currVitae.Titolo03_Desc = '';
                        vm.currVitae.Titolo03_Ist = '';
                        vm.currVitae.Titolo03_Mese = 0;
                        vm.currVitae.Titolo03_Anno = 0;
                        vm.currVitae.Titolo03_Voto = 0;
                        vm.currVitae.Titolo03_Max = 0;
                        vm.currVitae.Titolo03_Lode = false;
                    }
                    break;
            }
        }

        function setCompleted_CV() {
            if (!vm.currVitae.Sent && !vm.currVitae.Completed)
                bDialog.confirmationDialog('Attenzione', 'Completando non sar\xE0 possibile apportare modifiche al proprio CV.', 'OK').then(
                    function () { //YES
                        vm.currVitae.Completed = true;
                        return saveAll().then(function (data) {
                            if (data)
                                return printPDF_CV();
                            return true;
                        });
                    },
                    function () { //NO
                        //vm.record.Completed = false;
                    }
                );
        }

        function unlockCVItem() {
            if (vm.currVitae.Completed) {
                var item = vm.currVitae;
                var msg = item.CNDDomandaAdesioneId;
                bDialog.confirmationDialog('Attenzione', 'Sei sicuro di voler sbloccare il cv dell\'adesione (' + msg + ')', 'OK').then(
                    function () { //YES
                        return datacontext.cndCV_unlock(item).then(function (data) {
                            if (data != "204") return logError('Errore: operazione non consentita');
                            vm.currVitae.Completed = false;
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        function setSent_CV() {
            if (!vm.currVitae.Sent && vm.currVitae.Completed)
                bDialog.confirmationDialog('Attenzione', 'Effettuando la trasmissione non sar\xE0 possibile caricare altri documenti.', 'OK').then(
                    function () { //YES
                        vm.currVitae.Sent = true;
                        return saveAll().then(function (data) {
                            return true;
                        });
                    },
                    function () { //NO
                        //vm.currVitae.Sent = false;
                    }
                );
        }


        function saveAll() {
            if (vm.list.cv_specs.length > 0 && vm.list.cv_servizi.length > 0)
            {
                //console.log('SaveAll: entrambi > 0');
                return saveAllSpec().then(function (data) {
                    return saveAllServizio().then(function (data) {
                       return saveCV();
                    });
                });
            }
            else if (vm.list.cv_specs.length > 0 && vm.list.cv_servizi.length == 0) {
                //console.log('SaveAll: vm.list.cv_specs.length > 0');
                return saveAllSpec().then(function (data) {
                    return saveCV();
                });
            }
            else if (vm.list.cv_specs.length == 0 && vm.list.cv_servizi.length > 0) {
                //console.log('SaveAll: vm.list.cv_servizi.length > 0');
                return saveAllServizio().then(function (data) {
                    return saveCV();
                });
            }
            else { 
                //console.log('SaveAll: entrambi nulli');
                return saveCV();
            }
        }


        //***************************
        // Get URL Allegato CURRICULUM VITAE

        function getPDFCV() {
            return datacontext.cndCV_findCV($routeParams.domandaAdesioneUID, $routeParams.projectUID)
                .then(function (data) {                    
                    if (data && data.url) {
                        return vm.linkPDFCV = data.url;
                    }
                });
        }

        //*******************************
        // Print PDF CURRICULUM VITAE

        function printPDF_CV() {
            return datacontext.cndCV_printPDF($routeParams.projectUID, $routeParams.domandaAdesioneUID)
                .then(function (data) {
                    if (data && data.url) {
                        
                        return vm.linkPDFCV = data.url;
                    }
                });
        }


        //****************************
        // CND CV

        function getCV(Uid) {
            return datacontext.cndCV_getByDomandaUID(Uid).then(function (data) {
                if (data) {
                    vm.currVitae = data;

                    if (vm.currVitae.Completed) {
                        vm.showPanel_cv2 = false;
                        vm.showPanel_cv3 = false;
                        vm.showPanel_cv4 = false;
                        vm.showPanel_cv5 = false;
                    }

                    //Parametro di appoggio per send_Email
                    vm.currVitae.ProgettoUId = $routeParams.projectUID;

                    //azzero liste
                    vm.list.cv_specs = [];
                    vm.list.cv_servizi = [];

                    
                    getAllSpec(vm.currVitae.CNDDomandaAdesioneId);
                    getAllServizio(vm.currVitae.CNDDomandaAdesioneId);
                }
                
                return true;
            });
        }

        function saveCV() {
            if (vm.currVitae == null || vm.currVitae.Id == null)
            {
                vm.currVitae.CNDDomandaAdesioneId = vm.record.Id;
                return datacontext.cndCV_add(vm.currVitae).then(function (data) {
                    if (data) {
                        if (vm.showDivs.ableToPDF2)
                            printPDF_CV();
                    }

                    logSuccess('Dati salvati. ');
                    return true;
                });
            }
            else
            {
                return datacontext.cndCV_update(vm.currVitae).then(function (data) {
                    if (data)
                        if (vm.showDivs.ableToPDF2)
                            printPDF_CV();

                    logSuccess('Dati salvati. ');

                    return true;
                });
            }
        }

        //****************************
        // CNDCV_Spec

        function getAllSpec(domandaAdesioneId) {
            return datacontext.cndCVSpec_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
                return vm.list.cv_specs = data;
            });
        }

        function addSpec() {
            if (vm.cv_spec.Titolo == null || vm.cv_spec.Ente == null || vm.cv_spec.Mese == null || vm.cv_spec.Anno == null)
                return log('Riempi tutti i campi della scheda');

            vm.cv_spec.CNDDomandaAdesioneId = vm.record.Id;

            vm.list.cv_specs.push(vm.cv_spec);

            vm.cv_spec = {};
        }

        function deleteSpec(item) {
            if (item.Id > 0) {
                datacontext.cndCVSpec_delete(item.Id).then(function (data) { });
            }

            var index = vm.list.cv_specs.indexOf(item)
            vm.list.cv_specs.splice(index, 1);
        }

        function saveAllSpec() {
            var items = vm.list.cv_specs;

            return datacontext.cndCVSpec_saveAll(items).then(function (data) {
                //if (data == "404") return logError('Errore sul salvataggio. ');

                return true;//logSuccess('Record Salvati. ');
            });
        }

        //****************************
        // CNDCV_Servizio

        function getAllServizio(domandaAdesioneId) {
            return datacontext.cndCVServizio_getAll(0, 0, domandaAdesioneId, -1, -1, -1, -1, 'IDDomanda').then(function (data) {
                return vm.list.cv_servizi = data;
            });
        }

        function addServizio() {
            if (vm.cv_servizio.Ente == null || vm.cv_servizio.Descrizione == null || vm.cv_servizio.MeseDa == null || vm.cv_servizio.AnnoDa == null || vm.cv_servizio.MeseA == null || vm.cv_servizio.MeseA == null )
                return log('Riempi tutti i campi della scheda');

            vm.cv_servizio.CNDDomandaAdesioneId = vm.record.Id;

            vm.list.cv_servizi.push(vm.cv_servizio);

            vm.cv_servizio = {};
        }

        function deleteServizio(item) {
            if (item.Id > 0) {
                datacontext.cndCVServizio_delete(item.Id).then(function (data) { });
            }

            var index = vm.list.cv_servizi.indexOf(item)
            vm.list.cv_servizi.splice(index, 1);
        }

        function saveAllServizio() {
            var items = vm.list.cv_servizi;

            return datacontext.cndCVServizio_saveAll(items).then(function (data) {
                //if (data == "404") return logError('Errore sul salvataggio. ');

                return true;//logSuccess('Record Salvati. ');
            });
        }

        //************************END*****************************

		//Elenchi Parametri
		function getTSource(code) {
			if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
			});
		}

		function getTAttach(code) {
			if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
			});
        }

        

        function getTitoliStudio() {
            if (vm.cmblist.titoliStudio.length > 0) return;

            return datacontext.arrTitoliStudio().then(function (data) {
                return vm.cmblist.titoliStudio = data;
            });
        }

        function getStatiCivili() {
            if (vm.cmblist.staticivili.length > 0) return;

            return datacontext.arrStatiCivili().then(function (data) {
                return vm.cmblist.staticivili = data;
            });
        }

        function getStatoOccup() {
            if (vm.cmblist.statiOccup.length > 0) return;

            return datacontext.arrStatiOccup().then(function (data) {
                return vm.cmblist.statiOccup = data;
            });
        }

        function getProfili(progettoId) {
            if (vm.cmblist.profili.length > 0) return;
            
            return datacontext.cndTProfilo_getAll(progettoId).then(function (data) {
                return vm.cmblist.profili = data;
            });
        }

        

        //******************************
        // Birth
        function getPaesi_Nasc() {
            if (vm.cmblist.nasc_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.nasc_paesi = data;
            });
        }

        function getProvincie_Nasc() {
            if (vm.cmblist.nasc_province.length > 0) return;

			datacontext.arrProvince().then(function (data) {
                vm.cmblist.nasc_province = data;
			});
		}

        function resetComuni_Nasc(idprov) {
            vm.record.NascComuneId = 0;
            getComuni_Nasc(idprov);
        }

        function getComuni_Nasc(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.nasc_comuni = [];
            }

            if (vm.record.NascProvinciaId != idprov)
                vm.cmblist.nasc_comuni = [];

			return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.nasc_comuni = data;
			});
        }

        function reset_PaeseNasc() {
            if (vm.record.NascPaeseId != 0) {
                vm.record.NascProvinciaId = 0;
                resetComuni_Nasc(0);
            }
        }

        //******************************
        // Residenza
        function getPaesi_Res() {
            if (vm.cmblist.res_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.res_paesi = data;
            });
        }

        function getProvincie_Res() {
            if (vm.cmblist.res_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.res_province = data;
            });
        }

        function resetComuni_Res(idprov) {
            vm.record.ResComuneId = 0;
            getComuni_Res(idprov);
        }

        function getComuni_Res(idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.res_comuni = [];
            }

            if (vm.record.ResProvinciaId != idprov)
                vm.cmblist.res_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.res_comuni = data;
            });
        }

        function reset_PaeseRes() {
            if (vm.record.ResPaeseId != 0) {
                vm.record.ResProvinciaId = 0;
                resetComuni_Res(0);
            }
        }

        function reset_DomUgualeRes() {
            if (vm.record.DomUgualeRes == 0) {
                vm.record.DomPaeseId = '';
                vm.record.DomProvinciaId = '';
                vm.record.DomComuneId = '';
                vm.record.DomIndirizzo = '';
                vm.record.DomCap = '';
            }
        }


        //******************************
        // Domicilio
        function getPaesi_Dom() {
            if (vm.cmblist.dom_paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.dom_paesi = data;
            });
        }

        function getProvincie_Dom() {
            if (vm.cmblist.dom_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.dom_province = data;
            });
        }

        function resetComuni_Dom(idprov) {
            vm.record.DomComuneId = 0;
            getComuni_Dom(idprov);
        }

        function getComuni_Dom(idprov) {
            if (!idprov || idprov == 0) {
                
                return vm.cmblist.dom_comuni = [];
            }

            if (vm.record.DomProvinciaId != idprov)
                vm.cmblist.dom_comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.dom_comuni = data;
            });
        }

        function reset_PaeseDom() {
            if (vm.record.DomPaeseId != 0) {
                vm.record.DomProvinciaId = 0;
                resetComuni_Dom(0);
            }
        }

        //********************************
        //Dich1

        function getCittadinanze_Dich1_02() {
            if (vm.cmblist.dich1_02_cittadinanze.length > 0) return;

            datacontext.arrCittadinanze().then(function (data) {
                vm.cmblist.dich1_02_cittadinanze = data;
            });
        }

        function getProvincie_Dich1_03() {
            if (vm.cmblist.dich1_03_province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.dich1_03_province = data;
            });
        }

        function resetComuni_Dich1_03(idprov) {
            vm.record.Dich1_03_ComuneId = 0;
            getComuni_Dich1_03(idprov);
        }

        function getComuni_Dich1_03(idprov) {
            if (!idprov || idprov == 0) {
                vm.record.Dich1_03_ComuneId = 0;
                return vm.cmblist.dich1_03_comuni = [];
            }

            if (vm.record.Dich1_03_ProvinciaId != idprov)
                vm.cmblist.dich1_03_comuni = [];
                

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.dich1_03_comuni = data;
            });
        }


        function reset_Dich1_02() {
            if (!vm.record.Dich1_02) {
                vm.record.Dich1_02_CittadinanzaId = '';
            }
        }

        function reset_Dich1_05_condanne() {
            if (!vm.record.Dich1_05_Condanne) {
                vm.record.Dich1_05_Aree = '';
            }
        }

        function reset_Dich1_08() {
            if (!vm.record.Dich1_08) {
                vm.record.Dich1_08_Titolo = '';
            }
        }

        function reset_Dich2_09() {
            if (!vm.record.reset_Dich2_09) {
                vm.record.Dich2_09_Permesso = false;
            }
        }

        //************************
        //Func Delete

		function deleteAttach(item) {
			var msg = ' Allegato ' + item.Name;
			bDialog.deleteDialog(msg).then(function () {
				return datacontext.attach_delete(item.Id).then(function (data) {
				    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');

					var index = vm.list.attach.indexOf(item)
                    var att = {};
                    att.TAttachId = vm.list.attach[index].TAttachId;
                    att.TAttach = vm.list.attach[index].TAttach;
                    vm.list.attach[index] = att;
					//vm.list.attach.splice(index, 1);
					//vm.record.stat_numAttach = vm.record.stat_numAttach - 1;
				});
			});
		}

		//Metodi interfaccia Filtri
		function setfAttach() {
			if (vm.checkfAttach == false) {
				vm.fAttach.TAttachId = '';
			}
		}



		//****************************************************
		// OPEN MODAL DIALOG
		//****************************************************
		function addModal() {
			var modalInstance = modal.open({
				templateUrl: '/app/azienda/modal/aziendaAdd.html?version=19',
				controller: 'aziendaAdd',
				resolve: {
					istituti: function () {
						return vm.istituti;
					},
					istitutoId: function () {
						return null;
					},
					corsi: function () {
						return vm.corsi;
					},
					corsoId: function () {
						return null;
					},
					misure: function () {
						return vm.misure;
					},
					misuraId: function () {
						return null;
					},
					ruoloSoggettoId: function () {
						return vm.fRuoloSoggettoId_def;
					},
					tFormaGiuridica: function () {
						return vm.lstFormaGiuridica;
					},
					bAPL: function () {
					    return vm.fBApl_def;
					},
					bCPI: function () {
					    return vm.fBCpi_def;
                    },
                    isSuper: function () {
                        return null;
                    }
				}
			});

			modalInstance.result.then(function (returnItem) {
			    if (!returnItem) return logError('errore di creazione! ');
			    if (returnItem == "409") return logError('Azienda Esistente! ');
			    if (returnItem == "406") return logError('Azienda non inserita, perche\' Partita IVA e/o Codice Fiscale non valido');

				logSuccess('Dato salvato con successo! ');
				addRecord(returnItem.Id);
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
		};

        
		
		// ATTACH
        function addAttach(tAttachId) {
            var recTSource = { Id: vm.tSource.Id, Name: vm.tSource.Name }
            var recSource = { Id: vm.record.Id, Name: vm.record.RagioneSociale }

            var modalInstance = modal.open({
                templateUrl: '/app/attach/modal/attachAdd2.html?version=19',
                controller: 'attachAdd2',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return vm.tAttach_Needed;
                        //return vm.tAttach;
                    },
                    tAttachId: function () {
                        return tAttachId;
                    }
                }
            });

			modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
				if (returnItem == "400") return logError('Errore registrazione dati [' + returnItem + ']');

				logSuccess('Dato salvato con successo! ');
				getListAttach(vm.record.Id);
				//vm.record.stat_numAttach = vm.record.stat_numAttach + 1;
			}, function () {
				//log('Modal dismissed at: ' + new Date());
			});
		};

		

	    //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS DomandaAdesione FOR CF -#-#-#-#-#-#
		vm.existsCF = false;
		vm.searchCF = function (value) {
		    //console.log('searchCF()');
		    vm.existsCF = false;
		    if (value == undefined) return;
		    if (value.length != 16) return; //numero minimo di caratteri

            return datacontext.cndDomandaAdesione_exists(vm.record.Id, value, vm.record.ProgettoId).then(function (data) {
		        vm.existsCF = data;
		    });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            var requiredLen = 16;
            vm.validCF = false;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri

            return datacontext.validazione_cf(value).then(function (data) {
                return vm.validCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {
            vm.validFieldsCF = false;
            var requiredLen = 16;
            if (vm.record.CodiceFiscale == undefined) return;
            if (vm.record.CodiceFiscale.length != requiredLen) return; //numero minimo di caratteri
            var strDtNasc = common.dateToString(vm.record.NascData); //la data deve avere formato dd/MM/yyyy
            
            return datacontext.validazione_fieldsCF(vm.record.CodiceFiscale, vm.record.Nome, vm.record.Cognome, vm.record.Sesso, strDtNasc, vm.record.NascPaeseId, vm.record.NascComuneId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        }

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID IBAN -#-#-#-#-#-#
        vm.validIBAN = true;
        vm.getValidIBAN = function (value) {
            var requiredLen = 27;
            vm.validIBAN = false;
            if (value == undefined) return;
            if (value.length != requiredLen) return; //numero minimo di caratteri

            return datacontext.validazione_iban(value).then(function (data) {
                return vm.validIBAN = data;
            });
        }

	    
            
	}
})();
